import { formatPrice } from "../services/formatterService";
import { showAlertAtom, alertMessageAtom, orderAtom, isLoadingAtom } from "../atoms/atoms";
import { useAtom, useSetAtom } from "jotai";
import { IsValidEmail, OrderValidationMessage } from "../services/validationService";
import productApi from "../api/productApi";
import PaymentProviderInfo from "./PaymentProviderInfo";

const PaymentButton = ({ product }) => {

    const setShowAlert = useSetAtom(showAlertAtom);
    const setAlertMessage = useSetAtom(alertMessageAtom);
    const [order,setOrder] = useAtom(orderAtom);
    const setIsLoading = useSetAtom(isLoadingAtom);


    const handleClick = () => {
        const message = OrderValidationMessage(order);
        if (message.length === 0) {
            setIsLoading(true);
            createOrder();
        } else {
            setAlertMessage(message);
            setShowAlert(true);
            return false;
        }
    }

    const createOrder = () =>{
    
        const makeOrder = async () => {
            try {
                let response = await productApi.CreateOrder(order);
                if (response.data && response.data.redirectUrl) {
                    window.location.href = response.data.redirectUrl;
                    
                } else {
                    setAlertMessage('Nie udało nam się połączyc z dostawcą płatności. Spróbuj ponownie wkrótce.');
                    setShowAlert(true);
                    setIsLoading(false);
                }
                
            } catch (err) {
                setAlertMessage("Nie udało nam się połączyc z dostawcą płatności. Spróbuj ponownie wkrótce.");
                setShowAlert(true);
                setIsLoading(false);
            }
        }

        makeOrder();
    }

    return (
        <>
            <button className="btn btn-primary py-3 mt-5 w-100" onClick={handleClick}>
                <strong>
                    Kupuję i płacę teraz {formatPrice(product.list_price)} PLN
                </strong>
            </button>
            <PaymentProviderInfo />
        </>

    )
}

export default PaymentButton;